import { render } from "./ThreeDObjectEditorCmp.vue?vue&type=template&id=3a4c7bb6"
import script from "./ThreeDObjectEditorCmp.vue?vue&type=script&lang=js"
export * from "./ThreeDObjectEditorCmp.vue?vue&type=script&lang=js"

import "./ThreeDObjectEditorCmp.vue?vue&type=style&index=0&id=3a4c7bb6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__